/* Centralized static copy. The admin console can override any value
   by saving an entry in the `content` collection using the same key. */

export const NAV_LINKS = [
  { to: "/", label: "Accueil", key: "nav.home" },
  { to: "/assurances-professionnelles", label: "Assurances pro", key: "nav.assurances" },
  { to: "/sante-prevoyance", label: "Santé & prévoyance", key: "nav.sante" },
  { to: "/patrimoine-placements", label: "Patrimoine", key: "nav.patrimoine" },
  { to: "/vehicules-collection", label: "Véhicules de collection", key: "nav.vehicules" },
  { to: "/methode", label: "Méthode", key: "nav.methode" },
  { to: "/partenaires", label: "Partenaires", key: "nav.partenaires" },
  { to: "/contact", label: "Contact", key: "nav.contact" },
];

export const STATUTS = [
  { value: "particulier", label: "Particulier" },
  { value: "independant", label: "Indépendant" },
  { value: "dirigeant", label: "Dirigeant" },
  { value: "entreprise", label: "Entreprise" },
];

export const BESOINS = [
  { value: "assurance_pro", label: "Assurance professionnelle" },
  { value: "mutuelle", label: "Mutuelle / santé" },
  { value: "prevoyance", label: "Prévoyance" },
  { value: "patrimoine", label: "Patrimoine" },
  { value: "placement", label: "Placement" },
  { value: "autre", label: "Autre" },
];

export const METHOD_STEPS = [
  {
    n: "01",
    title: "Audit de votre situation",
    body: "Un premier échange approfondi pour comprendre votre contexte, vos contrats existants et vos objectifs.",
  },
  {
    n: "02",
    title: "Analyse fine de vos besoins",
    body: "Étude de vos besoins personnels, professionnels et patrimoniaux pour cartographier les couvertures pertinentes.",
  },
  {
    n: "03",
    title: "Sélection d'offres adaptées",
    body: "Comparaison rigoureuse parmi notre réseau de partenaires reconnus pour ne retenir que les solutions qui vous correspondent.",
  },
  {
    n: "04",
    title: "Ajustement sur mesure",
    body: "Ajustement contradictoire avec vous : garanties, franchises, options. Une solution réellement à votre image.",
  },
  {
    n: "05",
    title: "Mise en place complète",
    body: "Souscription, démarches administratives, résiliation des anciens contrats si nécessaire : nous nous occupons de tout.",
  },
];

export const HERO_BG =
  "https://images.unsplash.com/photo-1773678401653-6722e9026d22?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwyfHxkaWpvbiUyMGNpdHklMjBhcmNoaXRlY3R1cmUlMjByb29mfGVufDB8fHx8MTc4MTI3NDU0M3ww&ixlib=rb-4.1.0&q=85";

export const IMAGES = {
  dijonAccent:
    "https://images.unsplash.com/photo-1653502218528-de58ba1c9039?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHw0fHxkaWpvbiUyMGNpdHklMjBhcmNoaXRlY3R1cmUlMjByb29mfGVufDB8fHx8MTc4MTI3NDU0M3ww&ixlib=rb-4.1.0&q=85",
  vintageCars:
    "https://images.unsplash.com/photo-1472850156196-0156e307c552?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwzfHx2aW50YWdlJTIwY2xhc3NpYyUyMGNhciUyMGx1eHVyeXxlbnwwfHx8fDE3ODEyNzQ1NDN8MA&ixlib=rb-4.1.0&q=85",
  wealth:
    "https://images.unsplash.com/photo-1493934558415-9d19f0b2b4d2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwyfHx3ZWFsdGglMjBtYW5hZ2VtZW50JTIwY29uc3VsdGF0aW9uJTIwZGVza3xlbnwwfHx8fDE3ODEyNzQ1NDN8MA&ixlib=rb-4.1.0&q=85",
};
